// assets/sticky-atc.js
(function(){
  'use strict';

  function q(sel){ return document.querySelector(sel); }
  function qa(sel){ return Array.from(document.querySelectorAll(sel)); }

  function smoothScrollTo(targetY, duration) {
    return new Promise(function(resolve){
      var startY = window.scrollY || window.pageYOffset;
      var diff = targetY - startY;
      if (Math.abs(diff) < 2) { window.scrollTo(0, targetY); return resolve(); }
      var startTime = performance.now();
      function step(now){
        var t = Math.min(1, (now - startTime) / duration);
        t = (--t)*t*t + 1;
        window.scrollTo(0, Math.round(startY + diff * t));
        if (t < 1) requestAnimationFrame(step);
        else resolve();
      }
      requestAnimationFrame(step);
    });
  }

  function findOriginalButton() {
    // prefer the product form submit button
    return q('.product-form__submit') || q('form button[type="submit"]') || q('.product__info-container button') || q('button');
  }

  function createSticky(originalBtn) {
    // remove old sticky if present
    var old = q('#sticky-add-to-cart');
    if (old) old.parentNode.removeChild(old);

    var wrap = document.createElement('div');
    wrap.id = 'sticky-add-to-cart';
    wrap.className = 'sticky-add-to-cart';

    var inner = document.createElement('div');
    inner.className = 'product-form__buttons';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'StickyATCButton';

    // copy classes so theme CSS applies
    btn.className = (originalBtn.className || 'product-form__submit button button--full-width button--primary').trim();

    // try to copy full content (icons + text)
    try { btn.innerHTML = originalBtn.innerHTML || originalBtn.textContent || originalBtn.value || 'Add to cart'; }
    catch(e){ btn.textContent = originalBtn.textContent || originalBtn.value || 'Add to cart'; }

    inner.appendChild(btn);
    wrap.appendChild(inner);
    document.body.appendChild(wrap);

    return { wrap: wrap, btn: btn };
  }

  function copyVisualStyles(srcBtn, dstBtn) {
    try {
      var cs = getComputedStyle(srcBtn);
      if(!cs) return;
      // copy individual visual properties that ensure pixel parity
      var props = [
        'fontSize','fontWeight','fontFamily','lineHeight',
        'paddingTop','paddingRight','paddingBottom','paddingLeft',
        'borderRadius','boxShadow','borderWidth','borderStyle','borderColor',
        'letterSpacing','textTransform'
      ];
      props.forEach(function(p){
        try {
          var val = cs[p];
          if (val) dstBtn.style[p] = val;
        } catch(e){}
      });

      // copy background-image if present
      if (cs.backgroundImage && cs.backgroundImage !== 'none') {
        dstBtn.style.backgroundImage = cs.backgroundImage;
        dstBtn.style.backgroundSize = cs.backgroundSize;
        dstBtn.style.backgroundPosition = cs.backgroundPosition;
      } else if (cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)') {
        dstBtn.style.background = cs.backgroundColor;
      }

      // copy color
      if (cs.color) dstBtn.style.color = cs.color;

    } catch(e){}
  }

  function updateWidth(originalBtn, wrap) {
    try {
      var rect = originalBtn.getBoundingClientRect();
      var widthPx = Math.min(rect.width, window.innerWidth - 32); // margins
      wrap.style.width = Math.round(widthPx) + 'px';
    } catch(e){}
  }

  function shouldShowSticky(originalBtn) {
    var rect = originalBtn.getBoundingClientRect();
    // show only when the original button has been scrolled PAST the top of the viewport
    // i.e. original's bottom is <= 0 (it sits above the viewport)
    return rect.bottom <= 0;
  }

  function initSticky() {
    var originalBtn = findOriginalButton();
    if (!originalBtn) return;

    var created = createSticky(originalBtn);
    var wrap = created.wrap;
    var stickyBtn = created.btn;

    // on click: scroll original to align where sticky currently is
    stickyBtn.addEventListener('click', function(e){
      e.preventDefault();
      try {
        var origRect = originalBtn.getBoundingClientRect();
        var wrapRect = wrap.getBoundingClientRect();
        var currentScroll = window.scrollY || window.pageYOffset;
        var targetScroll = Math.max(0, Math.round(currentScroll + (origRect.top - wrapRect.top)));
        // header offset support
        if (typeof window.STICKY_ATC_OFFSET === 'number') targetScroll = Math.max(0, targetScroll - window.STICKY_ATC_OFFSET);
        var distance = Math.abs(targetScroll - currentScroll);
        var duration = Math.min(700, Math.max(200, Math.round(distance * 0.45)));
        smoothScrollTo(targetScroll, duration).then(function(){
          setTimeout(function(){ try{ originalBtn.focus({ preventScroll:false }); }catch(e){} }, 60);
        });
      } catch(e){}
    });

    // on scroll/resize we show/hide and sync visuals/width
    function onCheck() {
      try {
        if (shouldShowSticky(originalBtn)) {
          copyVisualStyles(originalBtn, stickyBtn);
          updateWidth(originalBtn, wrap);
          wrap.classList.add('skt-visible');
          wrap.setAttribute('aria-hidden','false');
          // ensure display via CSS class
          if (!wrap.classList.contains('skt-visible')) wrap.classList.add('skt-visible');
        } else {
          wrap.classList.remove('skt-visible');
          wrap.setAttribute('aria-hidden','true');
        }
      } catch(e){}
    }

    // initial sync
    onCheck();

    var throttled = false;
    function onScrollThrottle(){
      if (throttled) return;
      throttled = true;
      requestAnimationFrame(function(){
        onCheck();
        throttled = false;
      });
    }

    window.addEventListener('scroll', onScrollThrottle, { passive: true });
    window.addEventListener('resize', function(){
      updateWidth(originalBtn, wrap);
      onCheck();
    });

    // Theme editor hooks
    document.addEventListener('shopify:section:unload', function(){ try{ wrap.remove(); }catch(e){} });
    document.addEventListener('shopify:section:load', function(){ try{ updateWidth(originalBtn, wrap); onCheck(); }catch(e){} });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(initSticky, 80);
  } else {
    document.addEventListener('DOMContentLoaded', initSticky);
  }

})();
